export default __webpack_public_path__ + "static/media/price_group_grey.fbeecb91.svg";